export const CHANGE_PAGE_MODE = 'CHANGE_PAGE_MODE';
export const SET_TIME_RANGE = 'SET_TIME_RANGE';
export const SET_SERVICES_INFO = 'SET_SERVICES_INFO';
export const SET_SELECTED_SERVICE = 'SET_SELECTED_SERVICE';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
